import { Directive, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[UsMobileFormater]'
})
export class UsMobileFormater implements OnInit, OnDestroy {

  private sub?: Subscription;

  constructor(private ngControl: NgControl) { }
  ngOnInit() {
    this.sub = this.ngControl.control?.valueChanges?.subscribe(value => {
      if (!value) return;

      const formatted = this.format(value);
      if (value !== formatted) {
        this.ngControl.control?.setValue(formatted, { emitEvent: false });
      }
    });
  }
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;
    const formatted = this.format(input.value);
    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }
  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
  private format(value: string): string {
    // value = value.replace(/^\+?1/, '');

    const digits = value.replace(/\D/g, '').substring(0, 10);

    if (digits.length < 4) return digits;

    if (digits.length < 7) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }

    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
}
